import { useState } from 'react';

const faqs = [
  {
    q: 'How much does it cost to hire City to City Moving Company?',
    a: 'Our pricing depends on the size of your move, distance, and services needed. Local moves are typically priced hourly, while long-distance moves use flat-rate binding estimates. We provide free, no-obligation quotes so you always know what to expect upfront. Call (760) 625-7767 for a personalized estimate.',
  },
  {
    q: 'How far in advance should I book my move?',
    a: 'We recommend booking at least 2–4 weeks in advance, especially for weekend moves and month-end dates. That said, we do accommodate last-minute and same-day moves when available — just give us a call.',
  },
  {
    q: 'Do you provide packing materials and boxes?',
    a: 'Yes. We supply professional-grade boxes, moving blankets, bubble wrap, packing paper, and stretch wrap for all our full-service and packing-only jobs. Materials are included in full-service packages.',
  },
  {
    q: 'Are you licensed and insured for moving in California?',
    a: 'Absolutely. City to City Moving Company is fully licensed with the California Public Utilities Commission (CPUC) as a registered household goods carrier and carries comprehensive liability insurance on every move.',
  },
  {
    q: 'Can you move large or specialty items like pianos and antiques?',
    a: 'Yes! We have a dedicated specialty items team trained to move pianos (upright and grand), antique furniture, fine art, grandfather clocks, wine collections, and oversized items. Custom crating is available for high-value pieces.',
  },
  {
    q: 'Do you offer long-distance moving from Southern California?',
    a: 'Yes. We provide long-distance and interstate moving services from Southern California to all 50 states. We offer binding estimates, real-time shipment tracking, and a dedicated move coordinator for every long-distance relocation.',
  },
  {
    q: 'Do you offer commercial and office moving services?',
    a: 'Yes. We specialize in commercial moves including office relocations, retail transitions, and warehouse moves. We offer after-hours and weekend scheduling to minimize business downtime.',
  },
  {
    q: 'What areas in Southern California do you serve?',
    a: 'We serve all of Southern California from our three offices: Orange County (Irvine, Newport Beach, Anaheim), Coachella Valley (Indio, Palm Springs, Palm Desert), and Long Beach/South Bay. We also cover surrounding communities and can accommodate moves throughout the region.',
  },
];

export default function ServicesFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-4">FAQ</span>
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4">
            Frequently Asked Questions About Our Moving Services
          </h2>
          <p className="text-slate-600 text-lg">
            Real answers to the questions customers ask us most — written in plain language, no jargon.
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-slate-50 rounded-2xl border border-slate-200 overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-slate-100 transition-colors"
              >
                <span className="font-bold text-slate-900 text-sm leading-snug pr-4">{faq.q}</span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${openIndex === i ? 'bg-orange-500 text-white' : 'bg-white text-slate-500 border border-slate-200'}`}>
                  <i className={`text-sm ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-slate-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
